import { useUserChecklists } from '@/modules/checklists/hooks'
import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router'
import { useUser } from '@/utils/hooks'

export const AuthRoutes: React.JSX.CFC = () => {
  const user = useUser()
  const navigate = useNavigate()

  const { hasUnresolvedChecklists } = useUserChecklists(user)

  useEffect(() => {
    if (hasUnresolvedChecklists) void navigate('/mandatory-checklists')
  }, [hasUnresolvedChecklists, navigate])

  if (hasUnresolvedChecklists) return null

  return <Outlet />
}
